export default __webpack_public_path__ + "static/media/mc_tooltip_polygon.f8fbcb4b.svg";